"use client";

import React, { FunctionComponent } from "react";
import { Entry } from "contentful";

import Slider from "react-slick";

import {
  IComponentCollection,
  IComponentCollectionFields,
} from "@/types/generated/contentful";
import Block from "../block";

type Props = {
  content: IComponentCollection;
  contentSection?: boolean;
  richText?: boolean;
};

const ComponentCollection: FunctionComponent<Props> = ({
  content,
  contentSection = false,
  richText = false,
}) => {
  const {
    columnLayout,
    items,
    initialSlide,
    background,
    foreground,
    carousel,
  } = content.fields as IComponentCollectionFields;

  if (!items) return null;

  const gridCols = [
    "flex flex-col md:flex-row justify-center",
    "grid grid-cols-1",
    "grid md:grid-cols-2",
    "grid md:grid-cols-2 lg:grid-cols-3",
    "grid md:grid-cols-2 lg:grid-cols-4",
    "grid md:grid-cols-2 lg:grid-cols-5",
  ];

  if (carousel) {
    var settings = {
      arrows: false,
      adaptuiveHeight: true,
      customPaging: (i: number) => (
        <div className="mt-4 h-4 w-4 rounded-full bg-gray-400 text-transparent opacity-30">
          {i + 1}
        </div>
      ),
      dots: true,
      dotsClass: "slick-dots",
      infinite: false,
      speed: 500,
      initialSlide: initialSlide || 0,
      slidesToShow: columnLayout ? columnLayout : items.length,
      slidesToScroll: columnLayout,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div className="mx-auto mb-8 w-80 sm:mb-0 sm:w-[900px] md:w-full">
        <Slider {...settings}>
          {items.map((block, index) => (
            <div className="px-2 xl:px-4" key={index}>
              <Block block={block as Entry<any>} />
            </div>
          ))}
        </Slider>
      </div>
    );
  }

  return (
    <div
      className={`mx-auto rounded-xl${contentSection ? "" : "px-4 xl:container"}`}
      style={{
        backgroundColor: background || "transparent",
        ...(foreground && { color: foreground }),
      }}
    >
      <div className={`m-auto gap-2 ${gridCols[columnLayout]} md:gap-4`}>
        {items.map((block, index) => (
          <Block block={block as Entry<any>} key={index} />
        ))}
      </div>
    </div>
  );
};

export default ComponentCollection;
